import * as React from 'react';
import { st, classes } from './Text.st.css';
import './Text.responsive.st.css';
import TextBase from '../TextBase';
const Text = React.forwardRef(({ className, size = 'medium', weight = 'normal', skin = 'standard', disabled = false, ...props }, ref) => (React.createElement(TextBase, { ref: ref, ...props, type: "span", className: st(classes.root, {
        size,
        weight,
        skin: !disabled && skin,
        disabled,
    }, className) })));
export default Text;
//# sourceMappingURL=Text.js.map